// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Their heart is sustained and will not fear,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;until they see the downfall of their foes.<br> </p> </div></div>";
// Exports
module.exports = code;